
export default {

    log(data) {
        /** 生产:production 开发:development */
        if (process.env.NODE_ENV == "development") {
            console.log(data);
        }
    },

    //引入资源文件
    getAssetsFiles(filePath) {
        return require(`@/assets/${filePath}`);
    },

    //复制文案
    copyText(text){
        
    },

    /** 递归 深拷贝 对象 */
    copyObj(obj) {
        /** 判断是否对象 */
        let isObj = obj instanceof Object;
        if (!isObj) {
            // 不是对象则返回
            return obj;
        } else {
            /** 是否日期对象 */
            let isDate = obj instanceof Date;
            /** 是否 是否 数组对象 */
            // let isArray =  Array.isArray(obj);
            let isArray = obj instanceof Array;
            if (isDate) {
                /** 日期对象 重新生成日期对象 返回 */
                return new Date(obj);
            } else {
                /** 初始返回数据格式 */
                let retData = isArray ? [] : {};
                /** 遍历 对象 或 数组对象 进行递归拷贝 */
                for (let key in obj) {
                    retData[key] = this.copyObj(obj[key]);
                }
                return retData;
            }

        }
    },

    //设置Cooike
    //key(键)、val(值)、effTime(有效时长，单位：秒)
    setCookie(key, val, effTime) {
        var effDate = new Date();
        var effectiveTime = effTime || 3600;
        effDate.setTime(effDate.getTime() + effectiveTime * 1000);
        document.cookie = key + "=" + escape(val) + ";expires=" + effDate.toGMTString();
    },
    //获取Cookie值
    getCookie(key) {
        if (document.cookie.length > 0) {
            var kv_start = document.cookie.indexOf(key + "=");
            if (kv_start != -1) {
                kv_start = kv_start + key.length + 1;
                var kv_end = document.cookie.indexOf(";", kv_start);
                if (kv_end != -1) {
                    kv_end = document.cookie.length;
                    return unescape(document.cookie.substring(kv_start, kv_end));
                }
            }
        }
        return "";
    },
    //删除Coookie值
    removeCookie(key) {
        var reTimeTemp = new Date();
        reTimeTemp.setTime(reTimeTemp.getTime() - 1);
        var curVal = this.getCookie(key);
        if (curVal) {
            document.cookie = key + "=" + curVal + ";expires=" + reTimeTemp.toGMTString();
        }
    },

    formatJson(jsonStr) {
        var result = '';
        var level = 0;
        var i = 0;
        var j = 0;
        var inQuotationMarks = false;
        var currentChar = null;

        for (i = 0; i < jsonStr.length; i++) {
            currentChar = jsonStr.charAt(i);

            switch (currentChar) {
                case '{':
                case '[':
                    if (!inQuotationMarks) {
                        result += currentChar + '\n' + this.indent(level + 1);
                        level++;
                    } else {
                        result += currentChar;
                    }
                    break;
                case '}':
                case ']':
                    if (!inQuotationMarks) {
                        level--;
                        result += '\n' + this.indent(level) + currentChar;
                    } else {
                        result += currentChar;
                    }
                    break;
                case ',':
                    if (!inQuotationMarks) {
                        result += ',\n' + this.indent(level);
                    } else {
                        result += currentChar;
                    }
                    break;
                case ':':
                    if (!inQuotationMarks) {
                        result += ': ';
                    } else {
                        result += currentChar;
                    }
                    break;
                case '"':
                    if (i > 0 && jsonStr.charAt(i - 1) !== '\\') {
                        inQuotationMarks = !inQuotationMarks;
                    }
                    result += currentChar;
                    break;
                default:
                    result += currentChar;
                    break;
            }
        }

        return result;
    },

    indent(level) {
        var result = '';
        var i = 0;
        for (i = 0; i < level; i++) {
            result += '  ';
        }
        return result;
    },
    formatDate(date, format='YYYY-MM-DD HH:mm:ss') {
        date = new Date(date);

        const padZero = (num) => num < 10 ? '0' + num : num.toString();
    
        const year = date.getFullYear();
        const month = padZero(date.getMonth() + 1);  // 月份是从0开始的
        const day = padZero(date.getDate());
        const hour = padZero(date.getHours());
        const minute = padZero(date.getMinutes());
        const second = padZero(date.getSeconds());
    
        return format.replace(/YYYY/g, year)
                     .replace(/MM/g, month)
                     .replace(/DD/g, day)
                     .replace(/HH/g, hour)
                     .replace(/mm/g, minute)
                     .replace(/ss/g, second);
    }
    
}